export default __webpack_public_path__ + "static/media/the-lovers@2x.27f00d09.png";